import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomImage from '../../../../../v2-components/Antd/Image';
import { Icons } from '../constant/icons.constant';
import { Product } from '../constant/product.constant';
export const handleRecipeIcon = (product, width) => {
	// INICIO PARCHE
	// CONTEXTO: esta validacion se tiene que eliminar ya que la preescripcion debe venir como un atributo del producto
	// if (product.prescription_type === Product.NP && product.master_caegory.toLowerCase() !== Product.auxSlug) {
	// 	return;
	// }
	// FIN PARCHE

	if (product.prescription_type === Product.PM) {
		return;
	}
	if (width) {
		return <CustomImage width={width} src={Icons[Enviroment.COUNTRY][product.prescription_type]} />;
	}
	return <CustomImage src={Icons[Enviroment.COUNTRY][product.prescription_type]} />;
};

